<div class="row">
  <div *ngFor="let card of postCards" class="card mb-4 col-xl-4">
      <div class="rel">
          <img alt="image" class="card-img-top" [src]="card.image">
          <div class="card-img-overlay text-white">
              <div class="card-title-bottom color-white mb-2">
                  <h4 class="card-title mb-2">
                      <a>{{ card.title }}</a>
                  </h4>
                  <div>{{ card.timestamp | date: 'dd MMM yyyy' }}</div>
              </div>
          </div>
      </div>

      <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="d-inline-flex align-items-center">
                  <img alt="image" class="img-circle mr-3" [src]="card.author.image" width="40">
                  <div>
                      <h6 class="text-primary m-0">{{ card.author.name }}</h6><small class="text-muted">{{ card.author.position }}</small></div>
              </div>
              <div class="d-inline-flex">
                  <span class="text-muted pl-3 pr-3 text-center" style="border-right:1px solid rgba(0,0,0,.1);"><i class="fa fa-heart-o d-block font-16 mb-2"></i>124</span>
                  <span class="text-muted pl-3 pr-3 text-center"><i class="fa fa-comment-o d-block font-16 mb-2"></i>56</span>
              </div>
          </div>
          <p class="text-light">{{ card.content }}</p>
          <div class="text-right">
              <a class="d-inline-flex align-items-center text-primary" href="javascript:;">Read More<i class="ti-arrow-circle-right font-20 ml-2"></i></a>
          </div>
      </div>
  </div>
</div>
